import { create } from "zustand"

interface AuthState {
    token: string | null
    user: { id: string; role: string } | null
    isAuthenticated: boolean
    isInitialized: boolean
    setToken: (token: string | null) => void
    logout: () => void
    setAuth: (auth: boolean) => void
    setInitialized: (initialized: boolean) => void
}

export const useAuthStore = create<AuthState>((set) => ({
    token: null,
    user: null,
    isAuthenticated: false,
    isInitialized: false,
    setToken: (token) =>
        set({ token, isAuthenticated: !!token }),
    logout: () => set({ token: null, user: null, isAuthenticated: false }),
    setAuth: (auth) => set({ isAuthenticated: auth }),
    setInitialized: (initialized) => set({ isInitialized: initialized }),
}))
